// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"660":"507cc452","832":"922f1031"}[chunkId] + ".css";
};